import { ContainerModule, type ContainerModuleLoadOptions } from 'inversify';
import { ErrorDependencyTypes } from '@shared/common/error/error.dependency-types';
import { CockpitApiErrorHandlerService } from '@shared/common/error/data/service/cockpit-api-error-handler.service';
import { CockpitApiErrorDataTransformerLocator } from '@shared/common/error/data/resolver/cockpit-api-error-data-transformer.resolver';
import { ConstraintValidationApiErrorDataTransformer } from '@shared/common/error/data/transformer/constraint-validation-error.api-data-transformer';
import { UnknownApiErrorDataTransformer } from '@shared/common/error/data/transformer/unknown-error.api-data-transformer';

export const errorContainerModule = new ContainerModule((options: ContainerModuleLoadOptions) => {
  options
    .bind<CockpitApiErrorHandlerService>(ErrorDependencyTypes.CockpitApiErrorHandlerService)
    .to(CockpitApiErrorHandlerService);
  options
    .bind<CockpitApiErrorDataTransformerLocator>(ErrorDependencyTypes.CockpitApiErrorDataTransformerLocator)
    .to(CockpitApiErrorDataTransformerLocator);
  options
    .bind<ConstraintValidationApiErrorDataTransformer>(ErrorDependencyTypes.ConstraintValidationApiErrorDataTransformer)
    .to(ConstraintValidationApiErrorDataTransformer);
  options
    .bind<UnknownApiErrorDataTransformer>(ErrorDependencyTypes.UnknownApiErrorDataTransformer)
    .to(UnknownApiErrorDataTransformer);
});
